// extracted by mini-css-extract-plugin
export default {"zoomModal":"R1-z","image":"S1-z","button":"T1-z","isOverlayShown":"U1-z"};